<script setup>
// Team — the TENANT-ADMIN member-management page, in the consumer shell.
//
// A workspace/organization admin (tenant_admin role — NOT the platform
// isAdmin flag) manages their own members here: list, invite, edit roles,
// suspend. Backed by saas-core's /api/admin/* surface, which (since
// alpha.10) admits tenant admins and scopes every query to their tenant.
//
// Same wrapper pattern as AdminUsersPage.vue: AdminUsers emits invite/edit,
// this wrapper renders the modals and key-bounces the list to refresh.
import { ref } from "vue";
import AdminUsers from "@digitalstreams/saas-core/vue/admin/AdminUsers.vue";
import InviteUserModal from "@digitalstreams/saas-core/vue/admin/InviteUserModal.vue";
import EditUserModal from "@digitalstreams/saas-core/vue/admin/EditUserModal.vue";

const showInvite = ref(false);
const showEdit = ref(false);
const editingUser = ref(null);
const reloadKey = ref(0);

function onInvite() {
  showInvite.value = true;
}

function onEdit(user) {
  editingUser.value = user;
  showEdit.value = true;
}

function onInviteClose() {
  showInvite.value = false;
  reloadKey.value++;
}

function onEditClose() {
  showEdit.value = false;
  editingUser.value = null;
  reloadKey.value++;
}
</script>

<template>
  <div class="container-fluid p-0">
    <h1 class="h3 mb-1">Team</h1>
    <p class="text-muted mb-3">
      Invite and manage the members of your organization.
    </p>

    <AdminUsers
      :key="reloadKey"
      @invite="onInvite"
      @edit="onEdit"
    />
    <InviteUserModal
      :show="showInvite"
      @close="onInviteClose"
    />
    <EditUserModal
      :show="showEdit"
      :user="editingUser || {}"
      @close="onEditClose"
    />
  </div>
</template>
